import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { OptionActionInterface } from "src/app/shared/models/option-action.interface";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  saveOptionsSelector,
  updateFieldsSelector,
} from "src/app/store/settings/settings.selectors";
import { AdvertiserDetailsInterface } from "src/app/shared/models/advertiser/profile.interface";
import { CreateLocationPartnerComponent } from "src/app/components/admin/location-partners/create-location-partner/create-location-partner.component";
import { invokeUpdateAdvertiser } from "src/app/store/advertiser/advertiser.actions";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { ToastrService } from "ngx-toastr";
import { SubRoleInterface } from "src/app/shared/models/sub-role/subRole.interface";
import { UpdateRouterComponent } from "src/app/components/admin/router/update-router/update-router.component";
import { invokeUpdateRouter } from "src/app/store/router/router.action";
import { TranslateService } from "@ngx-translate/core";
import { TypeCards } from "src/app/shared/enum/typeCards";
import { UpdateLocationPartnerComponent } from "src/app/components/admin/location-partners/update-location-partner/update-location-partner.component";
import { LocationPartnerInterface } from "src/app/shared/models/location-partners/locationPartner.interface";
import {
  ActionInterface,
  createFranchised,
  OptionActionEnum,
} from "src/app/shared/data/actions-data";
import { invokeUpdateLocationPartner } from "src/app/store/locationPartner/actions/update.actions";
import {
  catchForbiddenErrorSelector,
  checkUserExistByEmailSelector,
} from "src/app/store/user/user.selectors";
import { RouterToUpdateInterface } from "src/app/shared/models/router/router-update.interface";
import { UpdateAdvertiserComponent } from "src/app/components/admin/advertisers/update-advertiser/update-advertiser.component";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { catchForbiddenError } from "src/app/store/user/user.actions";
import { CreateCampaignComponent } from "src/app/components/admin/location-partners/campagnes-lp/create-campaign/create-campaign.component";
import { saveUpdateFields } from "src/app/store/settings/settings.actions";
import { AssignFranchisedComponent } from "src/app/components/admin/location-partners/assign-franchised/assign-franchised.component";
import { invokeFranchiseFilter, invokeUpdateFranchise, updateFranchiseSuccess } from "src/app/store/franchise/franchise.action";
import { updateFranchiseSuccessSelector } from "src/app/store/franchise/franchise.selectors";
import { JwtService } from "src/app/shared/services/jwt.service";
import { initialState } from "src/app/store/franchise/franchise.reducers";
import { RoleEnum } from "src/app/shared/models/user/role.interface";

@Component({
  selector: "app-update",
  templateUrl: "./update.component.html",
})
export class UpdateComponent extends BaseComponent implements OnInit {
  updateFields$: Observable<OptionActionInterface | null>;
  updateFields: OptionActionInterface;

  advertiserEditProfileSuccess$: Observable<SuccessDto | null>;

  subRole: SubRoleInterface;
  routerType: boolean;
  routerToEdit: RouterToUpdateInterface;

  /** */
  saveOptions$: Observable<ActionInterface[] | null>;
  saveOption: ActionInterface[];
  @Input() type: TypeCards;
  @Input() title: string;
  @Input() isCol4: boolean;
  @Input() reference: string;
  option = OptionActionEnum;

  @Input() locationPartner: LocationPartnerInterface;

  isExist$: Observable<boolean | null>;
  typeCard = TypeCards;
  @Input() email: string;
  @Input() isMissingStatusData: boolean | null = false;
  @Input() isMissingRouterData: boolean | null = false;
  @Input() isFranchise: boolean | null = false;
  @Input() isFranchised: boolean | null = false;

  advertiser: AdvertiserDetailsInterface;

  catchForbiddenError$: Observable<boolean | null>;

  @Input() isConfirmButton : boolean = true
  createFranchised: ActionInterface[] = createFranchised;
  franchiseUpdated$: Observable<SuccessDto | null>;
  isAdminLoggedIn: boolean;


  constructor(
    private modalService: NgbModal,
    private store: Store<AppStateInterface>,
    private toastr: ToastrService,
    private translate: TranslateService,
    private saveHistory: SaveUserHistoryService,
    private jwtService: JwtService
  ) {
    super(store);
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.updateFields$ = this.store
      .pipe(select(updateFieldsSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.saveOptions$ = this.store
      .pipe(select(saveOptionsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.isExist$ = this.store
      .pipe(select(checkUserExistByEmailSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.franchiseUpdated$ = this.store
      .pipe(select(updateFranchiseSuccessSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {
    this.isAdminLoggedIn = this.jwtService.getRoleName(localStorage.getItem("token")) === RoleEnum.ROLE_ADMIN;
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.modalService.dismissAll();
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });

    this.isExist$.subscribe((data) => {
      if (data == true) {
        this.toastr.error(
          this.translate.instant("response.error.email-exist"),
          this.translate.instant("response.errorTitle")
        );
      }
    });

    this.saveOptions$.subscribe((data) => {
      if (data) {
        this.saveOption = data;
        if (this.isFranchised) {
          this.saveOption = this.saveOption.filter(({type}) => (
            type !== OptionActionEnum.ADMIN_UPDATE_LOCATION_PARTNER_STATUS_INFORMATION &&
            type !== OptionActionEnum.ADMIN_UPDATE_LOCATION_PARTNER_ROUTER_INFORMATION &&
            type !== OptionActionEnum.ADMIN_CREATE_SIMPLE_LOCATION
          ));
        }
        if (this.isFranchise) {
          this.saveOption = this.saveOption.filter(({type}) => (
            type !== OptionActionEnum.ADMIN_CREATE_SIMPLE_LOCATION
          ));
        }
      }
    });

    this.updateFields$.subscribe((result) => {
      if (result) {
        this.updateFields = result;
      }
    });

    this.franchiseUpdated$.subscribe((result) => {
      if (result) {
        this.toastr.success(
          this.translate.instant("response.success." + result.message),
          this.translate.instant("response.successTitle")
        );
        this.store.dispatch(updateFranchiseSuccess({ success: null }));
        this.store.dispatch(
          invokeFranchiseFilter({
              franchiseFilter: initialState.franchiseFilter,
          })
        );
      }
    });
  }
  onClickOpenModal(field: OptionActionEnum) {
    switch (this.type) {
      case TypeCards.ADMIN_FRANCHISE_UPDATE:
      case TypeCards.ADMIN_LOCATION_UPDATE: {
        this.onClickCloseModal();
        const modalRef = this.modalService.open(
          UpdateLocationPartnerComponent,
          {
            centered: true,
          }
        );
        modalRef.componentInstance.locationPartner = this.locationPartner;
        modalRef.componentInstance.email = this.email;
        modalRef.componentInstance.selectedOption = field;
        modalRef.componentInstance.isFranchise = this.isFranchise;
        modalRef.componentInstance.isFranchised = this.isFranchised;
        break;
      }
      case TypeCards.ADMIN_ROUTER_UPDATE: {
        this.onClickCloseModal();
        const modalRef = this.modalService.open(UpdateRouterComponent, {
          centered: true,
        });

        modalRef.componentInstance.routerToEdit = this.routerToEdit;
        modalRef.componentInstance.selectedOption = field;
        break;
      }
      case TypeCards.ADMIN_ADVERTISER_UPDATE: {
        this.onClickCloseModal();
        const modalRef = this.modalService.open(UpdateAdvertiserComponent, {
          centered: true,
        });

        modalRef.componentInstance.selectedOption = field;
        modalRef.componentInstance.advertiser = this.advertiser;
        modalRef.componentInstance.email = this.email;
        break;
      }
    }

    switch (field) {
      case OptionActionEnum.ADMIN_CREATE_FRANCHISE: {
        this.onClickCloseModal();
        const modalRef = this.modalService.open(
          CreateLocationPartnerComponent,
          {
            centered: true,
          }
        );
        modalRef.componentInstance.selectedOption = OptionActionEnum.ADMIN_CREATE_FRANCHISE;
        modalRef.componentInstance.isFranchise = true;

        break;
      }
      case OptionActionEnum.ADMIN_CREATE_ADVERTISING_CAMPAIGN_FOR_FRANCHISE:
      case OptionActionEnum.ADMIN_CREATE_ADVERTISING_CAMPAIGN_FOR_LOCATION_PARTNER: {
        this.onClickCloseModal();
        const modalRef = this.modalService.open(
          CreateCampaignComponent,
          {
            centered: true,
            size: "lg"
          }
        );
        modalRef.componentInstance.selectedOption = field;
        break;
      }
      case OptionActionEnum.ADMIN_CREATE_FRANCHISED: {
        this.onClickCloseModal();
        this.store.dispatch(saveUpdateFields({ options: this.createFranchised })); 
        const modalRef = this.modalService.open(
          UpdateComponent,
          {
            centered: true,
          }
        );
        modalRef.componentInstance.title = "FranchisedOptions.title";
        modalRef.componentInstance.type = TypeCards.ADMIN_FRANCHISED_CREATE;
        modalRef.componentInstance.selectedOption = OptionActionEnum.ADMIN_CREATE_FRANCHISED;
        break;
      }
      // CASE EXISTING LP ADMIN_ASSIGN_FRANCHISED
      case OptionActionEnum.ADMIN_ASSIGN_FRANCHISED: {
        this.onClickCloseModal();
        const modalRef = this.modalService.open(
          AssignFranchisedComponent,
          {
            centered: true,
          }
        );
        break;
      }

      // CASE NEW FRANCHISED ADMIN_CREATE_NEW_FRANCHISED
      case OptionActionEnum.ADMIN_CREATE_NEW_FRANCHISED: {
        this.onClickCloseModal();
        this.store.dispatch(saveUpdateFields({ options: this.createFranchised })); //TODO: define this
    
        const modalRef = this.modalService.open(
          CreateLocationPartnerComponent,
          {
            centered: true,
          }
        );
        modalRef.componentInstance.selectedOption = OptionActionEnum.ADMIN_CREATE_FRANCHISED;
        modalRef.componentInstance.isFranchised = true;
      }
    }
  }
  onClickCloseModal() {
    this.modalService.dismissAll(UpdateComponent);
  }
  onClickUpdate() {
    this.onClickCloseModal();
    switch (this.type) {
      // TODO: WHOLE STORE FLOW THING
      case TypeCards.ADMIN_FRANCHISE_UPDATE: {
        this.store.dispatch(
          invokeUpdateFranchise({
            email: this.email,
            franchiseDto: this.locationPartner,
          })
        );
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.PATCH,
          UserHistoryServicesEnum.UPDATE_LOCATION
        );
        break;
      }
      case TypeCards.ADMIN_LOCATION_UPDATE: {
        this.store.dispatch(
          invokeUpdateLocationPartner({
            email: this.email,
            locationPartnerDto: this.locationPartner,
          })
        );
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.PATCH,
          UserHistoryServicesEnum.UPDATE_LOCATION
        );
        break;
      }
      case TypeCards.ADMIN_ROUTER_UPDATE: {
        this.store.dispatch(
          invokeUpdateRouter({
            oldMAC: this.routerToEdit.mac,
            routerDto: this.routerToEdit.router,
          })
        );
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.PATCH,
          UserHistoryServicesEnum.UPDATE_ROUTER
        );
        break;
      }
      case TypeCards.ADMIN_ADVERTISER_UPDATE: {
        this.store.dispatch(
          invokeUpdateAdvertiser({
            email: this.email,
            profileDetails: {
              companyActivity: this.advertiser?.companyActivity,
              companyName: this.advertiser.companyName,
              email: this.advertiser.email.toLowerCase(),
              phone: this.advertiser.phone,
              companyAddress: this.advertiser.companyAddress,
              website: this.advertiser.website,
              logo: this.advertiser?.logo,
              firstName: this.advertiser?.firstName,
              lastName: this.advertiser.lastName,
              creationDate: this.advertiser.creationDate,
              birthday: this.advertiser.birthday,
              iberis: this.advertiser?.iberis,
              companyRole: this.advertiser?.companyRole,
              verified: this.advertiser.verified,
              status: this.advertiser.status,
              billingAddress: this.advertiser.billingAddress,
              legalName: this.advertiser.legalName,
              taxRegistration: this.advertiser.taxRegistration,
            },
          })
        );
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.PATCH,
          UserHistoryServicesEnum.UPDATE_ADVERTISER
        );
      }
    }
  }
}
